// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"d422b9f8","324":"981d74b7","411":"5e924cad","556":"b4e91714"}[chunkId] + ".chunk.js";
};